import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';

/**
 * EOD Report — lead cards (PRD screen 7): Leads received / actioned / converted on the report date, plus
 * walk-in leads logged. Read-only; does not change any EOD sales / walk-in / conversion number.
 * storeId: a Shopify location id, or 'all' (managers / HO). Server: GET /api/leads/reports/eod.
 * Renders nothing if the leads API is unavailable.
 */
export default function LeadsEodCards({ storeId, date }) {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!storeId) { setData(null); return; }
    api.get('/leads/reports/eod', { params: { storeId, date } }).then(r => setData(r.data)).catch(() => setData(null));
  }, [storeId, date]);
  if (!data) return null;
  const t = data.totals;
  const cards = [
    ['📥', 'Leads received', t.received, '#6d28d9', `${t.walkIns} walk-in${t.walkIns === 1 ? '' : 's'} logged`],
    ['📞', 'Leads actioned', t.actioned, '#2563eb', 'any call, task, stage change or note'],
    ['🛒', 'Leads converted', t.converted, '#15803d', t.convertedValue ? `₹${t.convertedValue.toLocaleString('en-IN')} · FTD conversion` : 'order linked']
  ];
  return (
    <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 14, padding: '12px 14px', marginBottom: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
        <div style={{ fontSize: 13, fontWeight: 800, color: '#334155', flex: 1 }}>Leads · {data.date}</div>
        <button onClick={() => navigate('/leads/analytics')} style={{ border: 'none', background: 'transparent', color: '#c88346', fontWeight: 700, fontSize: 12, cursor: 'pointer' }}>Lead analytics ›</button>
      </div>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        {cards.map(([icon, label, value, color, sub]) => (
          <div key={label} style={{ flex: '1 1 160px', border: '1px solid #f1f5f9', borderRadius: 10, padding: '10px 12px', background: '#fafafa' }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.4px' }}>{icon} {label}</div>
            <div style={{ fontSize: 22, fontWeight: 800, color, marginTop: 2 }}>{value}</div>
            <div style={{ fontSize: 11, color: '#94a3b8' }}>{sub}</div>
          </div>
        ))}
      </div>
      {data.stores.length > 1 && (
        <div style={{ marginTop: 8, fontSize: 11.5, color: '#64748b', display: 'flex', flexWrap: 'wrap', gap: '4px 14px' }}>
          {data.stores.map(s => <span key={s.storeId}>{s.storeName.replace(/^SleepyCat Sleep Studio\s*[-–]\s*/i, '')}: {s.received} / {s.actioned} / {s.converted}</span>)}
        </div>
      )}
    </div>
  );
}
